import { Box, Typography, Breadcrumbs, Link } from '@mui/material'
import { NavigateNext } from '@mui/icons-material'
import { Link as RouterLink } from 'react-router-dom'

interface PageHeaderProps {
  title: string
  subtitle?: string
  breadcrumbs?: { label: string; href?: string }[]
  action?: React.ReactNode
}

export function PageHeader({ title, subtitle, breadcrumbs, action }: PageHeaderProps) {
  return (
    <Box
      component="header"
      sx={{
        mb: { xs: 2.5, sm: 3.5 },
        position: 'relative',
        paddingInlineStart: { xs: 2, sm: 2.5 },
        '&::before': {
          content: '""',
          position: 'absolute',
          insetInlineStart: 0,
          top: breadcrumbs?.length ? 36 : 4,
          bottom: 4,
          width: 4,
          borderRadius: 4,
          background: 'linear-gradient(180deg, #1597E5, #20C997)',
        },
      }}
    >
      {breadcrumbs && breadcrumbs.length > 0 && (
        <Breadcrumbs
          separator={<NavigateNext fontSize="small" />}
          aria-label="breadcrumb"
          sx={{ mb: 1, '& .MuiBreadcrumbs-separator': { color: 'text.disabled' } }}
        >
          {breadcrumbs.map((b, i) =>
            b.href ? (
              <Link key={i} component={RouterLink} to={b.href} underline="hover" color="text.secondary" variant="body2">
                {b.label}
              </Link>
            ) : (
              <Typography key={i} variant="body2" color="text.primary">
                {b.label}
              </Typography>
            ),
          )}
        </Breadcrumbs>
      )}
      <Box sx={{ display: 'flex', alignItems: { xs: 'stretch', sm: 'center' }, justifyContent: 'space-between', gap: 2, flexDirection: { xs: 'column', sm: 'row' } }}>
        <Box sx={{ minWidth: 0 }}>
          <Typography variant="h4" sx={{ fontSize: { xs: 25, sm: 30 }, lineHeight: 1.15 }}>{title}</Typography>
          {subtitle && (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.65, maxWidth: 760 }}>
              {subtitle}
            </Typography>
          )}
        </Box>
        {action && <Box sx={{ flexShrink: 0, '& > .MuiButton-root': { width: { xs: '100%', sm: 'auto' } } }}>{action}</Box>}
      </Box>
    </Box>
  )
}
